<i *ngIf="!hasLimitedOptions" class="ml-auto pointer pi pi-ellipsis-h lession-more-icon absolute center folder-options-icon text-primary"
(click)="menu4.toggle($event)"></i>
<p-menu #menu4 popup="popup" [model]="getFolderContextMenu(folder)"
appendTo="body"></p-menu>
<div class="flex flex-column align-items-center" (click)="openFolderClicked()">
<img src="/assets/icons/folder-icon.svg" width="40">
<div class="folder-name-tag w-full text-center font-xs px-1">{{folder.name}}</div>
</div>